/**
 * Shared vertical rhythm for authenticated app pages.
 *
 * Compact by default; slight breathe from `xl` — avoid undoing header density
 * with large outer padding on tall screens.
 */
export const PAGE_STACK = 'space-y-2 sm:space-y-2.5 xl:space-y-3 2xl:space-y-4';
export const PAGE_GAP = 'gap-2 sm:gap-2.5 xl:gap-3 2xl:gap-4';
export const PAGE_GRID_GAP = 'gap-2.5 sm:gap-3 xl:gap-4 2xl:gap-5';

/**
 * Control height for page chrome (PageActions, filters, search).
 * Keep in sync with Button size="sm".
 */
export const CONTROL_SM = 'h-8 xl:h-9';
